<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <h1 id="jump-to-header">{{heading || generated_heading + " Update"}}</h1>
    <showing-update :id="id" @gotAttrs="assignAttrs"/>
  </div>
</template>

<script>
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import ShowingUpdate from './ShowingUpdate.vue'

export default {
  components: {
    VuexBreadcrumb,
    ShowingUpdate
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      attrs: {},
      generated_heading: undefined
    }
  },
  methods: {
    assignAttrs(attrs, description) {
      this.generated_heading = description
      this.attrs = Object.assign( {}, attrs)
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>